import { StandardAssetRaw } from '$components/Asset';
import { useFragment } from '$contentful-gql/fragment-masking';
import { responsiveContentfulImage } from '$providers/Assets/index';
import { assetFragment } from '$providers/common';
import { HTMLAttributes } from 'react';

import { HeroSlideImage } from './HeroSlideImage';
import { HeroSlideVideo } from './HeroSlideVideo';
import { IHeroSlide } from './types';

export function HeroSlide(props: IHeroSlide & HTMLAttributes<HTMLElement>) {
  const { assets } = props;
  const asset = StandardAssetRaw(assets);
  const image = useFragment(assetFragment, asset !== null ? asset.image : null);
  if (asset !== null && asset.assetType === 'image') {
    // Motion slide for video
    return (
      <HeroSlideImage
        {...props}
        imageWidth={image.width}
        imageHeight={image.height}
      >
        {responsiveContentfulImage({
          url: asset.url,
          w: 1440,
        })}
      </HeroSlideImage>
    );
  } else if (
    asset !== null &&
    (asset.assetType === 'video' || asset.assetType === 'videoWithPlaceholder')
  ) {
    let videoUrl = asset.videoUrl !== null ? asset.videoUrl : asset.url;

    // Static slide for video
    return (
      //<HeroSlideVideo placeholder={image !== null && typeof image.url === 'string' ? image.url : null} resolution={asset.videoResolution} {...props}>
      <HeroSlideVideo
        placeholder={image}
        resolution={asset.videoResolution}
        {...props}
      >
        {videoUrl}
      </HeroSlideVideo>
    );
  }
  return null;
}
